import React from 'react';
import { ArrowLeft } from './Icons';

// A simple components catalog that preserves the existing app look & feel.
// Consumers can pass onOpen(pageId) to navigate to a section.
const ComponentsCatalogPage = ({ language = 'traditional', onBack, onOpen }) => {
  const getText = (tc, sc, en) => {
    return language === 'traditional' ? tc : language === 'simplified' ? sc : en;
  };

  const sections = [
    {
      id: 'features',
      icon: '🧭',
      title: getText('應用功能', '应用功能', 'App Features'),
      description: getText('功能展示與分類', '功能展示与分类', 'Feature showcase and categories')
    },
    {
      id: 'ai_learning_assistant',
      icon: '🧠',
      title: getText('AI 學習助手', 'AI 学习助手', 'AI Learning Assistant'),
      description: getText('個人化建議與提醒', '个性化建议与提醒', 'Personalized guidance and reminders')
    },
    {
      id: 'grammar_topics',
      icon: '📚',
      title: getText('語法主題', '语法主题', 'Grammar Topics'),
      description: getText('90 個核心語法結構', '90 个核心语法结构', '90 core grammar structures')
    },
    {
      id: 'grammar_book',
      icon: '📖',
      title: getText('語法書', '语法书', 'Grammar Book'),
      description: getText('單元式學習內容', '单元式学习内容', 'Unit-based grammar content')
    },
    {
      id: 'learning_paths',
      icon: '🗺️',
      title: getText('學習路徑', '学习路径', 'Learning Paths'),
      description: getText('單元與課程進度', '单元与课程进度', 'Units and lesson progress')
    },
    {
      id: 'daily_challenges',
      icon: '🎯',
      title: getText('每日挑戰', '每日挑战', 'Daily Challenges'),
      description: getText('任務與成就系統', '任务与成就系统', 'Tasks and achievements')
    },
    {
      id: 'roleplay',
      icon: '🎭',
      title: getText('角色扮演', '角色扮演', 'Roleplay'),
      description: getText('情境對話練習', '情境对话练习', 'Scenario conversation practice')
    },
    {
      id: 'tone_learning',
      icon: '🎵',
      title: getText('語調學習', '语调学习', 'Tone Learning'),
      description: getText('語氣與語調單元', '语气与语调单元', 'Tone and intonation units')
    },
    {
      id: 'ar_practice',
      icon: '📷',
      title: getText('AR 練習', 'AR 练习', 'AR Practice'),
      description: getText('情境式擴增實境', '情境式扩增实境', 'Contextual AR practice')
    },
    {
      id: 'community_learning',
      icon: '👥',
      title: getText('社群學習', '社群学习', 'Community Learning'),
      description: getText('動態與語言交換', '动态与语言交换', 'Feed and language exchange')
    },
    {
      id: 'unit_studying',
      icon: '🧩',
      title: getText('單元學習', '单元学习', 'Unit Studying'),
      description: getText('單元課程與進度', '单元课程与进度', 'Unit lessons and progress')
    },
    {
      id: 'progress_tracker',
      icon: '📈',
      title: getText('學習進度', '学习进度', 'Progress Tracker'),
      description: getText('統計與回饋', '统计与回馈', 'Stats and feedback')
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      {/* Header */}
      <div className="px-6 py-6">
        <div className="flex items-center justify-between mb-6">
          <button onClick={onBack} className="text-white">
            <ArrowLeft size={24} />
          </button>
          <h1 className="text-xl font-bold">
            {getText('元件總覽', '元件总览', 'Components')}
          </h1>
          <div className="w-6"></div>
        </div>

        {/* Description */}
        <div className="mb-6 text-center">
          <p className="text-gray-300 text-sm">
            {getText('快速存取所有功能頁面', '快速存取所有功能页面', 'Quick access to all feature pages')}
          </p>
        </div>

        {/* Sections */}
        <div className="grid grid-cols-1 gap-4 mb-20">
          {sections.map((s) => (
            <button
              key={s.id}
              onClick={() => onOpen && onOpen(s.id)}
              className="bg-gray-800/30 border border-gray-600 rounded-xl p-4 text-left hover:bg-gray-700/40 transition-colors"
            >
              <div className="flex items-start space-x-4">
                <div className="text-3xl flex-shrink-0">{s.icon}</div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-white mb-1">{s.title}</h3>
                  <p className="text-gray-300 text-sm">{s.description}</p>
                </div>
                <div className="text-blue-400 text-lg">→</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ComponentsCatalogPage;


